import React from 'react';
import Moment from 'moment';

import * as Antd from 'antd';

export const DateRange = (props) => {  
  return (
    <Antd.DatePicker.RangePicker
      {...props}
      value={props.value
        ? [Moment(props.value[0]), Moment(props.value[1])]
        : null}
      ranges={{
        'Today': [Moment().startOf('day'), Moment().endOf('day')],
        'Yesterday': [Moment().startOf('day').subtract(1, 'day'), Moment().endOf('day').subtract(1, 'day')],
        'This week': [Moment().startOf('week'), Moment().endOf('week')],
        'This month': [Moment().startOf('month'), Moment().endOf('month')],
        'This year': [Moment().startOf('year'), Moment().endOf('year')],
        'Last week': [Moment().startOf('week').subtract(1, 'week'), Moment().endOf('week').subtract(1, 'week')],
        'Last month': [Moment().startOf('month').subtract(1, 'month'), Moment().endOf('month').subtract(1, 'month')],
        'Last year': [Moment().startOf('year').subtract(1, 'year'), Moment().endOf('year').subtract(1, 'year')],
      }}
    />
  );
};